// apps/web/src/lib/cookies.ts
'use client';

/**
 * Set a cookie
 * @param name - Cookie name
 * @param value - Cookie value
 * @param days - Expiration in days. If 0 or undefined, creates a session cookie (expires when browser closes)
 */
export function setCookie(name: string, value: string, days?: number) {
  if (typeof document === 'undefined') return;

  let cookieStr = `${name}=${encodeURIComponent(value)};path=/;SameSite=Lax`;

  if (days && days > 0) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    cookieStr += `;expires=${expires.toUTCString()}`;
  }
  // If days is 0 or undefined, no expires attribute = session cookie

  document.cookie = cookieStr;
}

export function deleteCookie(name: string) {
  if (typeof document === 'undefined') return;
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
}

export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;

  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';');

  for (const cookie of cookies) {
    const c = cookie.trim();
    if (c.startsWith(nameEQ)) {
      return decodeURIComponent(c.substring(nameEQ.length));
    }
  }
  return null;
}
